"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassThroughProxy = void 0;
/**
 * A proxy for testing that passes the func only through.
 */
class PassThroughProxy {
    /**
     * Executes a function within a resilience proxy.
     * @param func Function to execute within the resilience proxy.
     * @param requestId Request Guid.
     * @returns The result of the executed function.
     */
    execute(func, requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield func();
            return result;
        });
    }
}
exports.PassThroughProxy = PassThroughProxy;
//# sourceMappingURL=passThroughProxy.js.map